/**
 * @author      esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright   Copyright (c) 2021, Zumper
 * @description Breakpoints are used in media queries for mobile size devices and
 */

export const BREAKPOINT_MAX = '1600px' as const
export const BREAKPOINT_1440 = '1440px' as const
export const BREAKPOINT_1350 = '1350px' as const
export const BREAKPOINT_1280 = '1280px' as const
export const BREAKPOINT_1240 = '1240px' as const
export const BREAKPOINT_1220 = '1220px' as const
export const BREAKPOINT_1180 = '1180px' as const
export const BREAKPOINT_1160 = '1160px' as const
export const BREAKPOINT_1100 = '1100px' as const
export const BREAKPOINT_1080 = '1080px' as const
export const BREAKPOINT_1024 = '1024px' as const
export const BREAKPOINT_1020 = '1020px' as const
export const BREAKPOINT_1015 = '1015px' as const
export const BREAKPOINT_975 = '975px' as const
export const BREAKPOINT_950 = '950px' as const
export const BREAKPOINT_900 = '900px' as const
export const BREAKPOINT_890 = '890px' as const
export const BREAKPOINT_880 = '880px' as const
export const BREAKPOINT_870 = '870px' as const
export const BREAKPOINT_850 = '850px' as const
export const BREAKPOINT_800 = '800px' as const
export const BREAKPOINT_DESKTOP = '771px' as const
export const BREAKPOINT_MOBILE = '770px' as const // iPad
export const BREAKPOINT_740 = '740px' as const
export const BREAKPOINT_640 = '640px' as const
export const BREAKPOINT_580 = '580px' as const
export const BREAKPOINT_520 = '520px' as const
export const BREAKPOINT_480 = '480px' as const // iPhone 6+
export const BREAKPOINT_414 = '414px' as const
export const BREAKPOINT_380 = '380px' as const // iPhone 6
export const BREAKPOINT_374 = '374px' as const // to target iPhone device under 6
export const BREAKPOINT_320 = '320px' as const // iPhone 4, 5
